import { resolveComponent as s, createElementBlock as m, openBlock as n, renderSlot as a, createVNode as i, normalizeClass as r, withCtx as l, createElementVNode as c, toDisplayString as p } from "vue";
import { _ } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
import d from "../list-item/list-item.js";
const b = {
  name: "ComboboxEmptyList",
  components: { DtListItem: d },
  props: {
    /**
     * Message to display when list is empty
     */
    message: {
      type: String,
      required: !0
    },
    /**
     * Additional class name for the empty list element.
     * Can accept all of: String, Object, and Array, i.e. has the
     * same api as Vue's built-in handling of the class attribute.
     */
    itemClass: {
      type: [String, Object, Array],
      default: ""
    }
  }
}, f = {
  class: "d-combobox__empty-list",
  "data-qa": "dt-combobox-empty-list"
};
function u(e, y, t, x, C, g) {
  const o = s("dt-list-item");
  return n(), m("ol", f, [
    a(e.$slots, "default", {}, () => [
      i(o, {
        role: "option",
        "navigation-type": "none",
        type: "custom",
        class: r(["d-combobox__empty-list-item", t.itemClass])
      }, {
        default: l(() => [
          c("span", null, p(t.message), 1)
        ]),
        _: 1
      }, 8, ["class"])
    ])
  ]);
}
const L = /* @__PURE__ */ _(b, [["render", u]]);
export {
  L as default
};
//# sourceMappingURL=combobox-empty-list.js.map
